import React from "react";
import "../../../../../css/pages/ca_pages/teams/teams_model/DashboardTodayTasks.css";

const getPriorityColor = (priority) => {
    switch (priority) {
        case "critical":
            return "#dc2626";

        case "high":
            return "#ea580c";

        case "medium":
            return "#2563eb";

        case "low":
        default:
            return "#16a34a";
    }
};

const getStatusColor = (status) => {
    switch (status) {
        case "completed":
            return "#16a34a";

        case "in_progress":
            return "#2563eb";

        case "review":
            return "#7c3aed";

        case "paused":
            return "#ea580c";

        case "cancelled":
            return "#64748b";

        case "pending":
        default:
            return "#ea580c";
    }
};

const formatStatus = (status) => {
    if (!status) { return "Unknown"; }

    return status
        .replaceAll("_", " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
};

const DashboardTodayTasks = ({
    tasks = [],
}) => {
    return (
        <div className="today-card">
            <div className="today-header">
                <div>
                    <h2>Today's Tasks</h2>
                    <p>Tasks scheduled for today.</p>
                </div>

                <button>
                    View All
                </button>
            </div>

            <div className="today-list">
                {tasks.length === 0 ? (
                    <div
                        style={{
                            padding: "20px",
                            textAlign: "center",
                            color: "#64748b",
                        }}
                    >
                        No tasks scheduled for today.
                    </div>
                ) : (
                    tasks.map((task) => {
                        const statusColor = getStatusColor(task.status);
                        const priorityColor = getPriorityColor(task.priority);

                        return (
                            <div
                                key={task.id}
                                className="today-item"
                            >
                                <div className="today-left">
                                    <div className="today-title">
                                        {task.title}
                                    </div>

                                    <div className="today-employee">
                                        Due:{" "}
                                        {task.due_date
                                            ? new Date(
                                                task.due_date
                                            ).toLocaleTimeString(
                                                [],
                                                {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                }
                                            )
                                            : "--"}
                                    </div>
                                </div>

                                <div className="today-right">
                                    {task.priority && (
                                        <span
                                            className="today-priority"
                                            style={{
                                                background: `${priorityColor}15`,
                                                color: priorityColor
                                            }}
                                        >
                                            {formatStatus(task.priority)}
                                        </span>
                                    )}

                                    <span
                                        className="today-status"
                                        style={{ color: statusColor }}
                                    >
                                        {formatStatus(task.status)}
                                    </span>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default DashboardTodayTasks;
